module.exports = __webpack_public_path__ + "static/media/ICONS_WBN_PROFILE_PICTURE.7f4c5907.svg";